// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1g9y1","name":"ConsentHeader_name__xwdjW","birthday":"ConsentHeader_birthday__2Swjt","skeleton":"ConsentHeader_skeleton__CgtZF"};